import useField, { useFieldProps } from "./useField";

/**
 * Checkbox field. The persisted value is the *string* "true" / "false"
 * (empty / undefined reads back as unchecked on the backend via toBoolean).
 * The string <-> boolean conversion for the antd Checkbox is handled by the
 * 'checkbox' branch in SEFieldInput, so the form value stays a string and
 * flows through parseFormValues unchanged.
 */
const useCheckbox = <T>(props: useFieldProps<T>) => {
  const field = useField(props);
  return {
    ...field,
    fieldType: 'checkbox',
  };
};

export default useCheckbox;
